import React from "react";
import { Link } from "react-router-dom";

import chifcologo from "../assets/home/chifcologo.png"

export default ({ open, ...props }) => (
 <div> 
    <div className={open ? "burger-menu open" : "burger-menu"} {...props}>
      <div className="bar1" key="b1" />
      <div className="bar2" key="b2" />
      <div className="bar3" key="b3" />
    </div>
    <Link to="/" >
      <img src={chifcologo} style={{ width: "110px", float: "right", paddingTop: "30px", paddingRight: "20px"}} alt="" />
    </Link>
  </div>
);



// WEBPACK FOOTER //
// ./src/home/BurgerIcon.js